import { ServerDelegator } from'./server-delegator.class'
import { ErrorCode } from './error-code'

export class TestHelper {
  constructor() {
    this._reqId = 1
    this._server = new ServerDelegator(this)
    this._cb = undefined
    this._invoker = undefined
    this._syncReq = {}
  }

  _generateRequestNumber() {
    this._reqId += 1
    if (this._reqId > 2100000000) {
      this._reqId = 2
    }

    return this._reqId - 1
  }

  async _handleSync(event, payload) {
    const reqId = payload['_req_id']
    const target = payload['_from']
    if (this._syncReq[target] && this._syncReq[target][reqId]) {
      const timerValue = this._syncReq[target][reqId]['timer']
      if (timerValue !== 0 && timerValue !== ErrorCode.CHANNEL_TIMEOUT) {
        clearTimeout(timerValue)
        this._syncReq[target][reqId]['resolve'](payload)
      }
      delete this._syncReq[target][reqId]
    }
  }

  async _handleAsync(event, payload) {
    const sdk = payload['_from']
    const action = payload['_action']
    const reqId = payload['_req_id']
    const status = payload['_error'] === undefined
    if (this._cb) {
      this._cb(sdk, action, reqId, status, payload)
    }
  }

  async _handleInvoke(event, payload) {
    const sdk = payload['_from']
    const action = payload['_action']
    const param = payload['_payload']
    let res = {
      _to: sdk,
      _action: action,
      _from: 'end-user',
      _invoke: payload['_invoke']
    }
    if (this._invoker) {
      const result = await this._invoker(sdk, action, param)
      res['_return'] = result
    } else {
      res['_return'] = ErrorCode.NOT_REGISTERED_ACTION_INVOKER
    }
    this._server.onData(res)
  }

  async onData(event, payload) {
    const invokeId = payload['_invoke'] || 0
    return payload['_sync'] ? this._handleSync(event, payload) : invokeId > 0 ?
            this._handleInvoke(event, payload) : this._handleAsync(event, payload)
  }

  requestJson(to, action, payload) {
    return new Promise((resolve, reject) => {
      const req = {
        _to: to,
        _from: 'game',
        _action: action,
        _req_id: this._generateRequestNumber(),
        _sync: true,
        _data: payload
      }
      const reqId = req['_req_id']
      const target = req['_to']
      if (!this._syncReq[target]) {
        this._syncReq[target] = {}
      }

      if (!this._syncReq[target][reqId]) {
        this._syncReq[target][reqId] = {
          resolve,
          'timer': 0
        }
      }
      this._syncReq[target][reqId]['timer'] = setTimeout(() => {
        clearTimeout(this._syncReq[target][reqId]['timer'])
        this._syncReq[target][reqId]['timer'] = ErrorCode.CHANNEL_TIMEOUT
        resolve(ErrorCode.CHANNEL_TIMEOUT)
      }, 60 * 1000)
      this._server.onData(req)
    })
  }

  requestJsonAsync(to, action, payload) {
    const reqId = this._generateRequestNumber()
    const req = {
      _to: to,
      _from: 'game',
      _action: action,
      _req_id: reqId,
      _sync: false,
      _data: payload
    }
    this._server.onData(req)
    return reqId
  }

  addModule(name, module) {
    this._server.addModule(name, module)
  }

  registerInfaceListener(cb) {
    this._cb = cb
  }

  registerActionInvoker(invoker) {
    this._invoker = invoker
  }
}
